import React, { FC } from 'react';

import ComposeMetaStatus from '../../../../containers/compose/composeMetaStatus';
import ComposeMetaTemplate from '../../../../containers/compose/composeMetaTemplate';
import { ComposeNodeType } from '../../../../containers/compose/props';
import { Topic } from '../../../../generated/graphql';
import useComposeType from '../../../../hooks/router/search/useComposeType';

import * as Styled from './styled';

type Props = {
  nodeType: ComposeNodeType;
  topicId: Topic['id'] | null;
};

/**
 * Compose modal first section with template and status selection
 *
 * @param props          Props passed to the component
 * @param props.nodeType The type of node [MESSAGE, TEMPLATE]
 * @param props.topicId  The ID of the topic
 * @returns              Component itself
 */
const ComposeModalTemplateStatus: FC<Props> = props => {
  const composeType = useComposeType();

  const isMessage = props.nodeType === 'MESSAGE';
  const isTask = composeType === 'task';

  return (
    <Styled.Wrapper>
      {isMessage && <ComposeMetaTemplate {...props} />}
      {isTask && <ComposeMetaStatus {...props} />}
    </Styled.Wrapper>
  );
};

export default ComposeModalTemplateStatus;
